import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinwagholi() {



  const cardData = {



keyword: "Cab Service in Wagholi",

headingDescription: "Garud Cab Service provides comfortable and reliable Cab Service in Wagholi for corporate professionals, families, tourists, students, senior citizens, and groups looking for convenient local and outstation transportation. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for office travel, airport transfers, railway station pickups, corporate meetings, local transportation, one-way journeys, round trips, sightseeing, and customized outstation trips. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations across Wagholi, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes business and leisure travel smooth and convenient. Travelers can also arrange private cabs from Wagholi to hill stations, pilgrimage destinations, coastal getaways, major cities, and other outstation locations according to their preferred schedule.",

topPlaces: [
  {
    title: "Shirdi",
    description: "Shirdi is a major pilgrimage destination visited by devotees throughout the year for Sai Baba darshan. Families, senior citizens, and groups from Wagholi can travel comfortably in a private chauffeur-driven cab with convenient door-to-door transportation. Garud Cab Service offers flexible one-way, round-trip, and overnight travel options with suitable vehicles."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a revered pilgrimage destination in the Sahyadri region, surrounded by forests and scenic mountain landscapes. Travelers from Wagholi can book a private cab for a comfortable family or devotional journey. Customers can choose Sedan, Ertiga, Innova, or Innova Crysta and customize their pickup and return schedule."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for scenic viewpoints, waterfalls, lakes, green valleys, and strawberry farms. It is ideal for families, couples, and groups planning a weekend getaway from Wagholi. Garud Cab Service provides comfortable chauffeur-driven vehicles with flexible sightseeing and multi-day travel options."
  },
  {
    title: "Panchgani",
    description: "Panchgani offers peaceful mountain scenery, viewpoints, valleys, and pleasant surroundings and can easily be combined with a Mahabaleshwar trip. Travelers from Wagholi can enjoy a private road journey with customized sightseeing stops. Customers can book suitable vehicles according to passenger count and luggage requirements."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious and commercial destination known for temples, heritage attractions, vineyards, and scenic locations. Customers from Wagholi can arrange private cabs for pilgrimage, business travel, family visits, or sightseeing. Garud Cab Service offers flexible one-way and round-trip transportation with professional chauffeurs."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular Konkan destination known for beaches, forts, resorts, and relaxing coastal surroundings. Families and groups from Wagholi can plan a comfortable weekend road trip using a private cab. Customers can customize the journey with nearby beaches and sightseeing locations and choose flexible return arrangements."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a culturally important city known for Mahalaxmi Temple, historic attractions, traditional food, and regional heritage. Travelers from Wagholi can book private cabs for pilgrimage, family visits, business travel, or sightseeing. Spacious vehicles are suitable for longer journeys and passengers carrying luggage."
  },
  {
    title: "Goa",
    description: "Goa is a popular long-distance destination for families, couples, friends, and groups looking for beaches, heritage attractions, markets, and coastal experiences. Customers from Wagholi can book a private chauffeur-driven cab for direct travel with luggage. Garud Cab Service offers one-way, round-trip, and multi-day vehicle options."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad, officially known as Chhatrapati Sambhajinagar, is a major heritage destination featuring historic monuments, caves, temples, and cultural attractions. Families and tourists from Wagholi can arrange a comfortable private cab for sightseeing or personal travel. Customers can customize their itinerary with multiple heritage stops."
  },
  {
    title: "Gokarna",
    description: "Gokarna is a popular coastal and pilgrimage destination known for beaches, temples, scenic landscapes, and a relaxed atmosphere. Travelers planning a longer road trip from Wagholi can choose a spacious Innova or Innova Crysta for added comfort. Garud Cab Service provides private chauffeur-driven travel with flexible multi-day itineraries."
  }
],




"services": [
  {
    "name": "Cab Service in Wagholi",
    "description": "Cab Service in Wagholi provides convenient transportation for local travel, airport transfers, office commutes, family journeys, and outstation trips. Sedan, SUV, Ertiga, Innova, and other suitable vehicles can be arranged according to passenger and luggage requirements."
  },
  {
    "name": "Cab Service in Wagholi Pune",
    "description": "Cab Service in Wagholi Pune offers private transportation for residents, professionals, students, families, and visitors. Local rides, airport transfers, railway station drops, sightseeing trips, and intercity journeys can be arranged with suitable vehicle options."
  },
  {
    "name": "Taxi Service in Wagholi",
    "description": "Taxi Service in Wagholi is suitable for passengers looking for comfortable transportation within Pune and to nearby destinations. Private cabs can be arranged for daily travel, business meetings, airport transfers, family trips, and outstation journeys."
  },
  {
    "name": "Taxi Service in Wagholi Pune",
    "description": "Taxi Service in Wagholi Pune provides practical travel solutions for local and long-distance transportation. Customers can select comfortable AC sedans, SUVs, Ertiga, Innova, and other vehicles based on their destination, passenger count, and travel requirements."
  },
  {
    "name": "Wagholi Cab Service",
    "description": "Wagholi Cab Service helps passengers arrange private transportation for everyday travel, airport pickups, office journeys, railway station transfers, and outstation trips. Flexible cab options can be selected for individual passengers, families, and groups."
  },
  {
    "name": "Wagholi Taxi Service",
    "description": "Wagholi Taxi Service offers convenient transportation from Wagholi to different parts of Pune and popular destinations outside the city. One-way drops, round trips, local rides, airport travel, and customized journeys can be arranged according to the requirement."
  },
  {
    "name": "Cab Booking in Wagholi",
    "description": "Cab Booking in Wagholi allows travelers to arrange transportation in advance for local and outstation journeys. Suitable cars can be selected for airport transfers, business travel, family trips, railway station drops, sightseeing, and intercity transportation."
  },
  {
    "name": "Taxi Booking in Wagholi",
    "description": "Taxi Booking in Wagholi provides a convenient way to plan private transportation according to the required travel schedule. Sedan, SUV, Ertiga, and Innova options can be arranged for local rides, airport transfers, one-way journeys, and round trips."
  },
  {
    "name": "Cabs in Wagholi",
    "description": "Cabs in Wagholi are suitable for residents and visitors requiring comfortable transportation across Pune and beyond. Vehicle options can be arranged for daily travel, corporate transportation, airport transfers, family outings, sightseeing, and long-distance journeys."
  },
  {
    "name": "Best Cab Service in Wagholi",
    "description": "Best Cab Service in Wagholi is designed for travelers seeking comfortable and convenient transportation for different purposes. Well-maintained vehicles can be arranged for local travel, airport transfers, corporate journeys, family trips, and outstation destinations."
  },
  {
    "name": "Affordable Cab Service in Wagholi",
    "description": "Affordable Cab Service in Wagholi offers practical transportation options for customers planning local and intercity journeys. Sedan, Ertiga, SUV, and Innova vehicles can be selected according to budget, passenger capacity, luggage, and destination requirements."
  },
  {
    "name": "Reliable Cab Service in Wagholi",
    "description": "Reliable Cab Service in Wagholi provides planned transportation for important journeys such as airport drops, business meetings, family travel, railway station transfers, and outstation trips. Customers can arrange suitable vehicles according to their preferred schedule."
  },
  {
    "name": "Outstation Cab Service in Wagholi",
    "description": "Outstation Cab Service in Wagholi provides private transportation from Wagholi to destinations across Maharashtra and neighboring regions. One-way drops, round trips, family vacations, pilgrimage tours, business travel, and weekend journeys can be arranged with suitable vehicles."
  },
  {
    "name": "One-way Cab from Wagholi",
    "description": "One-way Cab from Wagholi is convenient for passengers who need a private drop without requiring a return journey. One-way transportation can be arranged to Mumbai, Nashik, Shirdi, Lonavala, Mahabaleshwar, Aurangabad, and other destinations."
  },
  {
    "name": "Round-trip Cab from Wagholi",
    "description": "Round-trip Cab from Wagholi is suitable for travelers planning return journeys for sightseeing, family visits, business travel, weekend holidays, and religious tours. The vehicle can remain available according to the planned travel schedule and itinerary."
  },
  {
    "name": "Wagholi to Mumbai Cab",
    "description": "Wagholi to Mumbai Cab provides private intercity transportation for professionals, families, and individual travelers. One-way and round-trip options can be arranged for business visits, airport connections, shopping trips, and other travel requirements."
  },
  {
    "name": "Wagholi to Mumbai Airport Cab",
    "description": "Wagholi to Mumbai Airport Cab offers convenient transportation for passengers traveling to Mumbai Airport for domestic or international flights. Scheduled airport drops can be arranged with sedan, SUV, Ertiga, and Innova vehicles according to luggage and passenger requirements."
  },
  {
    "name": "Wagholi to Shirdi Cab",
    "description": "Wagholi to Shirdi Cab provides comfortable private transportation for devotees and families traveling to Shirdi for Sai Baba darshan. One-way, round-trip, overnight, and customized pilgrimage journeys can be arranged with suitable AC vehicles."
  },
  {
    "name": "Wagholi to Nashik Cab",
    "description": "Wagholi to Nashik Cab is suitable for business travel, family visits, sightseeing, and religious journeys. Travelers can arrange one-way or round-trip transportation with comfortable vehicles based on the number of passengers and luggage."
  },
  {
    "name": "Wagholi to Lonavala Cab",
    "description": "Wagholi to Lonavala Cab offers convenient transportation for weekend getaways, family outings, and short hill-station trips. Private AC cabs can be arranged for one-way travel, round trips, sightseeing, and flexible day-return journeys."
  },
  {
    "name": "Wagholi to Mahabaleshwar Cab",
    "description": "Wagholi to Mahabaleshwar Cab provides comfortable transportation for families, couples, and groups planning a hill-station vacation. Sedan, Ertiga, SUV, and Innova options can be arranged for one-way drops, round trips, and sightseeing tours."
  },
  {
    "name": "Wagholi to Bhimashankar Cab",
    "description": "Wagholi to Bhimashankar Cab is suitable for devotees and travelers visiting the Bhimashankar Jyotirlinga temple. Same-day return trips, family pilgrimage journeys, sightseeing, and customized religious tours can be arranged with comfortable private vehicles."
  },
  {
    "name": "Wagholi to Ranjangaon Cab",
    "description": "Wagholi to Ranjangaon Cab provides convenient transportation for devotees visiting the Ashtavinayak temple at Ranjangaon. Private cabs can be arranged for one-way travel, same-day round trips, family darshan, and customized temple tours."
  },
  {
    "name": "Wagholi to Jejuri Cab",
    "description": "Wagholi to Jejuri Cab is suitable for passengers planning Khandoba Temple darshan and religious sightseeing. Sedan, SUV, Ertiga, and Innova vehicles can be arranged for one-way journeys, round trips, family visits, and temple tours."
  },
  {
    "name": "Wagholi to Alibaug Cab",
    "description": "Wagholi to Alibaug Cab is convenient for families, couples, and groups planning beach holidays and weekend coastal trips. Private AC vehicles can be arranged for one-way travel, round trips, sightseeing, and flexible Alibaug itineraries."
  },
  {
    "name": "Wagholi to Kolhapur Cab",
    "description": "Wagholi to Kolhapur Cab offers private intercity transportation for family visits, business travel, sightseeing, and religious journeys. Comfortable vehicles can be arranged for one-way drops, round trips, and longer travel plans."
  },
  {
    "name": "Wagholi to Aurangabad Cab",
    "description": "Wagholi to Aurangabad Cab provides comfortable transportation for travelers visiting Aurangabad for business, family requirements, sightseeing, and heritage trips. Sedan, SUV, Ertiga, and Innova options can be selected according to group size."
  },
  {
    "name": "Cab Service in Kharadi",
    "description": "Cab Service in Kharadi provides convenient local and outstation transportation for residents, IT professionals, business travelers, and families. Cabs can be arranged for airport transfers, office travel, railway stations, sightseeing, and intercity journeys."
  },
  {
    "name": "Cab Service in Kesnand",
    "description": "Cab Service in Kesnand offers private transportation for local travel and outstation journeys from the Kesnand area. Suitable vehicles can be arranged for airport transfers, office travel, family trips, railway station drops, and long-distance destinations."
  },
  {
    "name": "Cab Service in Lohegaon",
    "description": "Cab Service in Lohegaon provides convenient transportation for residents and travelers requiring local, airport, and outstation travel. Sedan, SUV, Ertiga, and Innova options can be arranged for airport transfers, business journeys, family travel, and intercity trips."
  },
  {
    "name": "Cab Service in Viman Nagar",
    "description": "Cab Service in Viman Nagar is suitable for airport transfers, corporate travel, hotel transportation, local journeys, and outstation trips. Private AC vehicles can be arranged for individuals, families, executives, and groups."
  },
  {
    "name": "Cab Service in Chandan Nagar",
    "description": "Cab Service in Chandan Nagar offers convenient transportation for local and outstation requirements. Passengers can arrange private cabs for airport transfers, office travel, railway station drops, family journeys, sightseeing, and long-distance destinations."
  },
  {
    "name": "Cab Service in Keshav Nagar",
    "description": "Cab Service in Keshav Nagar provides comfortable transportation for residents, professionals, and families traveling across Pune or to outstation destinations. Vehicles can be arranged for airport travel, local transfers, business trips, and weekend journeys."
  },
  {
    "name": "Cab Service Near EON IT Park",
    "description": "Cab Service Near EON IT Park is suitable for IT professionals, corporate employees, visitors, and business travelers requiring convenient transportation. Airport transfers, office travel, client meetings, railway station drops, and outstation journeys can be arranged."
  },
  {
    "name": "Cab Service Near World Trade Center Pune",
    "description": "Cab Service Near World Trade Center Pune provides transportation for corporate professionals, business visitors, executives, and employees. Private cabs can be arranged for office transfers, airport travel, meetings, hotel drops, and intercity business journeys."
  },
  {
    "name": "Kharadi to Pune Airport Cab",
    "description": "Kharadi to Pune Airport Cab provides convenient airport transportation for passengers traveling from Kharadi to Pune Airport. Early-morning departures, scheduled pickups, family transfers, corporate travel, and luggage-friendly vehicles can be arranged."
  },
  {
    "name": "Wagholi to Kharadi Cab",
    "description": "Wagholi to Kharadi Cab offers convenient transportation between two important Pune areas for professionals, residents, students, and daily travelers. Private cabs can be arranged for office transfers, business meetings, scheduled travel, and local transportation."
  },
  {
    "name": "Wagholi to Pune Railway Station Cab",
    "description": "Wagholi to Pune Railway Station Cab helps passengers reach the railway station comfortably for scheduled train journeys. Sedan, SUV, Ertiga, and Innova vehicles can be arranged according to passenger count, luggage, and departure timing."
  },
  {
    "name": "Wagholi to Shivajinagar Cab",
    "description": "Wagholi to Shivajinagar Cab provides convenient local transportation for professionals, students, residents, and visitors. Direct private cabs can be arranged for office travel, business meetings, shopping, railway connections, and other city travel requirements."
  },
  {
    "name": "Wagholi to Hadapsar Cab",
    "description": "Wagholi to Hadapsar Cab offers comfortable transportation between Wagholi and Hadapsar for office commuters, residents, and business travelers. Private cabs can be arranged for scheduled transfers, daily journeys, airport connections, and local travel."
  },
  {
    "name": "Cab Service in Wagholi",
    "description": "Cab Service in Wagholi provides flexible transportation for local rides, airport transfers, railway station travel, corporate requirements, family outings, and outstation journeys. Multiple vehicle categories can be arranged according to the planned journey."
  },
  {
    "name": "Cab Service in Wagholi Pune",
    "description": "Cab Service in Wagholi Pune offers private transportation for daily city travel and long-distance journeys. Customers can arrange sedan, SUV, Ertiga, and Innova vehicles for airport drops, business travel, family trips, sightseeing, and outstation transportation."
  },
  {
    "name": "Taxi Service in Wagholi",
    "description": "Taxi Service in Wagholi provides convenient private transportation for passengers traveling within Pune or to other cities. One-way drops, round trips, airport transfers, local rides, corporate travel, and family journeys can be planned with suitable vehicles."
  },
  {
    "name": "Wagholi to Pune Airport Cab",
    "description": "Wagholi to Pune Airport Cab is suitable for travelers requiring timely transportation from Wagholi to Pune Airport. Private AC vehicles can be arranged for individuals, families, corporate travelers, and passengers carrying additional luggage."
  },
  {
    "name": "Pune Airport to Wagholi Cab",
    "description": "Pune Airport to Wagholi Cab provides convenient pickup transportation for passengers arriving at Pune Airport. Drivers can take travelers to homes, hotels, offices, and other locations in Wagholi with suitable vehicle options."
  },
  {
    "name": "Outstation Cab Service in Wagholi",
    "description": "Outstation Cab Service in Wagholi supports long-distance travel to destinations across Maharashtra and neighboring states. One-way and round-trip cabs can be arranged for vacations, pilgrimages, corporate journeys, family travel, and sightseeing."
  },
  {
    "name": "Local Cab Service in Wagholi",
    "description": "Local Cab Service in Wagholi provides convenient transportation for daily city journeys, office travel, shopping, medical visits, railway stations, and airport connections. Comfortable private vehicles can be arranged according to the required pickup and destination."
  },
  {
    "name": "24/7 Cab Service in Wagholi",
    "description": "24/7 Cab Service in Wagholi is suitable for passengers requiring transportation during early mornings, late nights, weekends, and different travel schedules. Airport transfers, local rides, railway station drops, and outstation journeys can be arranged."
  },
  {
    "name": "Cab Booking in Wagholi",
    "description": "Cab Booking in Wagholi allows passengers to organize their transportation in advance for local and outstation travel. Suitable vehicle categories can be selected for airport transfers, business trips, family journeys, sightseeing, one-way drops, and round trips."
  }
],
"tableData": [
  ["Cab Service in Wagholi", "Cab Service in Wagholi Pune"],
  ["Taxi Service in Wagholi", "Taxi Service in Wagholi Pune"],
  ["Wagholi Cab Service", "Wagholi Taxi Service"],
  ["Cab Booking in Wagholi", "Taxi Booking in Wagholi"],
  ["Cabs in Wagholi", "Best Cab Service in Wagholi"],
  ["Affordable Cab Service in Wagholi", "Reliable Cab Service in Wagholi"],
  ["Outstation Cab Service in Wagholi", "One-way Cab from Wagholi"],
  ["Round-trip Cab from Wagholi", "Wagholi to Mumbai Cab"],
  ["Wagholi to Mumbai Airport Cab", "Wagholi to Shirdi Cab"],
  ["Wagholi to Nashik Cab", "Wagholi to Lonavala Cab"],
  ["Wagholi to Mahabaleshwar Cab", "Wagholi to Bhimashankar Cab"],
  ["Wagholi to Ranjangaon Cab", "Wagholi to Jejuri Cab"],
  ["Wagholi to Alibaug Cab", "Wagholi to Kolhapur Cab"],
  ["Wagholi to Aurangabad Cab", "Cab Service in Kharadi"],
  ["Cab Service in Kesnand", "Cab Service in Lohegaon"],
  ["Cab Service in Viman Nagar", "Cab Service in Chandan Nagar"],
  ["Cab Service in Keshav Nagar", "Cab Service Near EON IT Park"],
  ["Cab Service Near World Trade Center Pune", "Kharadi to Pune Airport Cab"],
  ["Wagholi to Kharadi Cab", "Wagholi to Pune Railway Station Cab"],
  ["Wagholi to Shivajinagar Cab", "Wagholi to Hadapsar Cab"],
  ["Cab Service in Wagholi", "Cab Service in Wagholi Pune"],
  ["Taxi Service in Wagholi", "Wagholi to Pune Airport Cab"],
  ["Pune Airport to Wagholi Cab", "Outstation Cab Service in Wagholi"],
  ["Local Cab Service in Wagholi", "24/7 Cab Service in Wagholi"],
  ["Cab Booking in Wagholi", "Wagholi Cab Service"]
]
,



whychoose: [
  {
    WhyChooseheading: "Cab Service in Wagholi for Local & Outstation Travel",
    WhyChoosedescription: "Private cab transportation in Wagholi is a convenient choice for residents, professionals, families, students, and visitors travelling to workplaces, airports, railway stations, hotels, shopping areas, and outstation destinations."
  },
  {
    WhyChooseheading: "Pickup from Your Preferred Wagholi Location",
    WhyChoosedescription: "Passengers can arrange pickup from their home, apartment, office, hotel, society, commercial location, or another accessible point in Wagholi according to their planned journey."
  },
  {
    WhyChooseheading: "Convenient for Office & Business Travel",
    WhyChoosedescription: "Professionals and businesses can use private cabs for office commutes, client meetings, business appointments, corporate events, and travel between Wagholi and important commercial areas in Pune."
  },
  {
    WhyChooseheading: "Airport & Railway Station Transfers",
    WhyChooseheading: "Airport & Railway Station Transfers",
    WhyChoosedescription: "A private cab can be arranged for travel from Wagholi to Pune Airport, Pune Railway Station, and other transport points, providing direct transportation for passengers travelling with luggage."
  },
  {
    WhyChooseheading: "Comfortable for Families & Groups",
    WhyChoosedescription: "Families, couples, and groups can choose a suitable vehicle according to passenger count, luggage requirements, journey distance, and preferred comfort level."
  },
  {
    WhyChooseheading: "Useful for Daily Local Travel",
    WhyChoosedescription: "Wagholi cab services can be used for shopping trips, hotel transfers, hospital visits, educational institutions, residential travel, restaurants, business locations, and other destinations across Pune."
  },
  {
    WhyChooseheading: "One-Way & Outstation Cab Options",
    WhyChoosedescription: "Travellers can arrange one-way or round-trip cabs from Wagholi to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Satara, Goa, and other preferred cities."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Wagholi pickup point, destination, travel date, passenger count, luggage details, preferred vehicle, and local or outstation requirement with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Cab Service in Wagholi?",
    answer: "Yes, Garud Cab Service provides private cab services in Wagholi for local travel, corporate transportation, airport transfers, railway station travel, family trips, and outstation journeys."
  },
  {
    question: "Can I book a cab from anywhere in Wagholi?",
    answer: "Yes, pickup can be arranged from a preferred accessible location in Wagholi, including homes, apartments, offices, hotels, residential societies, and commercial locations."
  },
  {
    question: "Can I book a cab from Wagholi to Pune Airport?",
    answer: "Yes, private airport transfer services can be arranged from Wagholi to Pune Airport according to your preferred travel date and flight schedule."
  },
  {
    question: "Can I book a cab from Wagholi to Pune Railway Station?",
    answer: "Yes, a private cab can be arranged for direct transportation from Wagholi to Pune Railway Station or another preferred railway station location."
  },
  {
    question: "Does the service provide outstation cabs from Wagholi?",
    answer: "Yes, one-way and round-trip outstation cabs can be arranged from Wagholi to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Satara, Goa, and other cities."
  },
  {
    question: "Is the Wagholi cab service suitable for families?",
    answer: "Yes, families and groups can select a suitable vehicle based on passenger numbers, luggage requirements, journey distance, and preferred comfort level."
  },
  {
    question: "Can companies book cabs in Wagholi?",
    answer: "Yes, companies can arrange private cabs for employee travel, client meetings, office visits, corporate events, business appointments, and other professional transportation requirements."
  },
  {
    question: "Can I book a one-way cab from Wagholi?",
    answer: "Yes, one-way cab service can be arranged when you need direct transportation from Wagholi to your preferred destination without requiring the same vehicle for the return journey."
  },
  {
    question: "Can I carry luggage in a Wagholi cab?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger or additional baggage requirements should be communicated during booking."
  },
  {
    question: "How can I book a Cab Service in Wagholi?",
    answer: "Share your Wagholi pickup location, destination, travel date, passenger details, luggage requirements, preferred vehicle, and local or outstation travel requirement with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Manish Shinde",
    feedback: "I arranged a private cab from Wagholi for an airport transfer and found the direct pickup very convenient. Travelling with luggage was also easier than arranging multiple transport options.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavya Joshi",
    feedback: "Our family booked a cab from Wagholi for an outstation trip. The private vehicle allowed us to travel together comfortably and manage our luggage without any difficulty.",
    rating: 5
  }
];





  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Wagholi",
  "image": "https://garudcabs.com/assets/images/cab-service-in-wagholi.webp",
  "description": "Book Cab Service in Wagholi with Garud Cab for safe, comfortable, and reliable local, airport, corporate, and outstation transportation. Get taxi and cab booking services across Wagholi Pune for daily commuting, business travel, airport transfers, family journeys, sightseeing, and intercity trips. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles with convenient pickup and drop facilities and flexible one way or round trip options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/cab-service-in-wagholi"
  }
};



  return (
    <div>



<Helmet>
  <title>Cab Service in Wagholi | Taxi & Cab Booking Pune | +91 9970007784</title>

  <meta
    name="description"
    content="Book Cab Service in Wagholi Pune with Garud Cab for reliable local, airport, corporate, and outstation travel. Get taxi and cab booking services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Cab Service in Wagholi, Cab Service in Wagholi Pune, Taxi Service in Wagholi, Taxi Service in Wagholi Pune, Wagholi Cab Service, Wagholi Taxi Service, Cab Booking in Wagholi, Taxi Booking in Wagholi, Cabs in Wagholi, Best Cab Service in Wagholi, Wagholi Outstation Cab, Wagholi Airport Cab, Wagholi Local Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/110.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinwagholi;